export const EVENTMOBI_URLS = {
  // EventMobi Homepage (with UTM parameters)
  HOME_WITH_UTM: `https://eventmobi.com/?utm_medium=referral&utm_campaign=EventMobi_App&utm_content=Customer_Event`,
  // EventMobi Homepage (without UTM parameters)
  HOME: 'https://eventmobi.com',
  TERMS_OF_USE: `https://eventmobi.com/terms-of-use`,
  PRIVACY_POLICY: `https://eventmobi.com/privacy-policy`,
};

export const SUPPORT_URLS = {
  KNOWLEDGE_BASE: `https://help.eventmobi.com/en/knowledge`,
  WHATS_NEW: `https://help.eventmobi.com/en/knowledge/new-features-updates`,
};
